import React, {useContext} from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import TableContainer from '@mui/material/TableContainer'
import Table from '@mui/material/Table'
import FilterChip from './components/filter-chip'
import HomeworkFilters from './components/homework-filters'
import HomeworksHead from './components/homeworks-head'
import HomeworksBody from './components/homeworks-body'
import CreateHomework from './components/create-homework' 
import DeleteHomework from './components/delete-homework'

import {TeacherContext} from 'teacher/context'

const useStyles = makeStyles(homeworkStyles)

export default function Homeworks() {

  const context = useContext(TeacherContext)
  const {translate} = context
  const classes = useStyles()  
  const path = context.link('homeworks')

  return (
    <Box className={classes.root} > 
      <Box className={classes.filters}>
        <HomeworkFilters context={context} />
        <CreateHomework context={context} />
        <DeleteHomework />
      </Box>
      <Box className={classes.chips}>
        {context.query.pattern && <FilterChip name="pattern" context={context} path={path} />}
        {context.query.id && <FilterChip name="id" context={context} createLabel={() => translate('new-homework')} path={path} />}
      </Box>
      <Box className={classes.content}>
        <TableContainer className={classes.container}>
          <Table className={classes.table}>
            <HomeworksHead context={context} />
            <HomeworksBody context={context} />
          </Table>
        </TableContainer>
      </Box>
    </Box>
  )
}

function homeworkStyles() {
 return {
    root: {
      flexGrow: 1,
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#fff',
      borderRadius: '4px',
      boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)'
    },
    content: {
      display: 'flex',
      flexGrow: 1,
      overflow: 'hidden',
    },
    container: {
      flexGrow: 1,
      overflow: 'auto',
    },
    chips: {
      padding: 10,
      '& .filter-chip': {
        backgroundColor: '#de3434',
        color: '#fff',
        '& .MuiChip-label': {
          padding: '0 20px'
        },
        '& .MuiChip-deleteIcon': {
        }
      }
    },
    filters: {
      display: 'flex',
      padding: '0 15px 8px 15px',
      "& .create-quiz-wrapper": {
        display: "flex",
        marginTop: 15,
        flexDirection: "column",
        justifyContent: "center",
        paddingLeft: 15
      }
    },
    createButton: {
      margin: '10px'
    }
  }
}
